import "./PlayerModel.scss";
import "../../section.scss";
import PlayerPlace from "./PlayerPlace";
export default function PlayerModel({
  player_name,
  marker,
  percentage,
  wpm,
  position,
}) {
  return (
    <div>
      <div className="section--three-grid">
        <p></p>
        <div>
          <p style={{ color: "white" }}>{`guest-${player_name}`}</p>
        </div>
        <p></p>
      </div>
      <div className="section--three-grid">
        <div className="player-model__marker">
          <h1
            style={{
              color: "#2687F6",
            }}
            className={`${marker === false ? "section--r" : null}`}
          >
            YOU
          </h1>
        </div>
        <div>
          <div className="player-model">
            <div
              className="player-model__progress"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
        </div>
        <div className="player-model__wpm">
          <PlayerPlace place={position} />
          <h1>{wpm}</h1>
        </div>
      </div>
    </div>
  );
}
